<template>
    <dv-full-screen-container>
        <div class="linea-mainContainer">
            <div class="mainHead">
                <div class="headLeft">
                    <dv-decoration-8 :color="['#47A8ED', '#47A8ED']" style="width: 500px; height: 50px" />
                </div>
                <div class="middleOfHead">
                    <div class="headerText">
                        <img alt="塑业实时数据大屏" src="@/assets/img/logo.png" />
                        <p>塑业实时数据大屏</p>
                    </div>
                    <dv-decoration-5 :color="['#47A8ED', '#47A8ED']" :dur="10" style="width: 700px; height: 40px" />
                </div>
                <div class="headRight">
                    <dv-decoration-8
                        :color="['#47A8ED', '#47A8ED']"
                        :reverse="true"
                        style="width: 500px; height: 50px"
                    />
                </div>
            </div>
            <div class="contentBox">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="leftBox">
                            <div class="upperLeft" style="height: 100%">
                                <dv-border-box-12
                                    :color="['#0E4E80', '#1A92E8']"
                                    backgroundColor="rgba(5,21,57,0.3)"
                                    class="upperLeftBox"
                                >
                                    <div class="titleGroup">
                                        <div class="titleBox">切料控制台</div>
                                        <div class="toggleButtonGroup">
                                            <a
                                                :class="cuttingTabActive === 0 ? 'toggleActivation' : ''"
                                                @click="cuttingTabActive = 0"
                                            >
                                                实时值
                                            </a>
                                            <span>丨</span>
                                            <a
                                                :class="cuttingTabActive === 1 ? 'toggleActivation' : ''"
                                                @click="cuttingTabActive = 1"
                                            >
                                                设定值
                                            </a>
                                        </div>
                                    </div>
                                    <ul v-if="cuttingTabActive === 0" class="contentGroup">
                                        <li>
                                            <p>
                                                切割实际长度累计：<span>{{ lineB.motor.data15 }}</span>
                                            </p>
                                            <p>
                                                切割根数累计：<span>{{ lineB.motor.data16 }}</span>
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                切割样品根数：<span>{{ lineB.motor.data17 }}</span>
                                            </p>
                                            <p>
                                                切割样品长度：<span>{{ lineB.motor.data18 }}</span>
                                            </p>
                                        </li>
                                    </ul>
                                    <ul v-if="cuttingTabActive === 1" class="settingContentGroup">
                                        <li>
                                            <p>
                                                切割设定长度：<span>{{ lineB.motor.data19 }}</span>
                                            </p>
                                            <p>
                                                废品设定长度：<span>{{ lineB.motor.data20 }}</span>
                                            </p>
                                        </li>
                                    </ul>
                                </dv-border-box-12>
                            </div>
                            <!--<div class="lowerLeft">-->
                            <!--    &lt;!&ndash;废弃&ndash;&gt;-->
                            <!--</div>-->
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="middleBox">
                            <div class="upperMiddle">
                                <line-change-moudle />
                                <div class="floorPlan">
                                    <img alt="" src="../../assets/img/plan/plan@2x.png" />
                                </div>
                            </div>
                            <div class="middleDown">
                                <dv-border-box-11 :color="['#47A8ED', '#2972A6']" title="温度观测台">
                                    <div class="swiper-box">
                                        <swiper ref="mySwiper" :options="swiperOptions">
                                            <swiper-slide>
                                                <div class="temperatureGroup">
                                                    <temp-b name="熔体温度" :current-temp="lineB.xian.tc5" />
                                                    <template v-for="index in 4">
                                                        <temp-b
                                                            :key="'b1' + index"
                                                            :name="`EH${index}`"
                                                            :heating-state="lineB.sw[`sw${index}`]"
                                                            :set-temp="lineB.xian[`tc${100 + index}`]"
                                                            :current-temp="lineB.xian[`tc${index}`]"
                                                        />
                                                    </template>
                                                    <template v-for="index in 5">
                                                        <temp-b
                                                            :key="'b2' + index"
                                                            :name="`ED${index}`"
                                                            :heating-state="lineB.sw[`sw${index + 4}`]"
                                                            :set-temp="lineB.xian[`tc${104 + index}`]"
                                                            :current-temp="lineB.xian[`tc${index + 5}`]"
                                                        />
                                                    </template>
                                                </div>
                                            </swiper-slide>
                                            <swiper-slide>
                                                <div class="temperatureGroup">
                                                    <template v-for="index in 6">
                                                        <temp-b
                                                            :key="'b3' + index"
                                                            :name="`ED${index + 5}`"
                                                            :heating-state="lineB.sw[`sw${index + 9}`]"
                                                            :set-temp="lineB.xian[`tc${109 + index}`]"
                                                            :current-temp="lineB.xian[`tc${index + 10}`]"
                                                        />
                                                    </template>
                                                </div>
                                            </swiper-slide>
                                            <div slot="pagination" class="paginationDiy swiper-pagination"></div>
                                        </swiper>
                                    </div>
                                </dv-border-box-11>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="rightBox">
                            <div class="upperRight" style="height: 40%">
                                <dv-border-box-12 :color="['#0E4E80', '#2972A6']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="upperRightBox">
                                        <div class="titleBox">米重控制台</div>
                                        <div class="contentGroup">
                                            <li>
                                                <p>
                                                    米重设定值：<span>{{ lineB.motor.data14 }}</span>
                                                </p>
                                                <p>
                                                    米重实际值：<span>{{ lineB.motor.data13 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    平均壁厚值：<span>{{ lineB.motor.data21 }}</span>
                                                </p>
                                                <p>
                                                    偏心值：<span>{{ lineB.motor.data22 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    平均外径实际值：<span>{{ lineB.motor.data23 }}</span>
                                                </p>
                                                <p>
                                                    壁厚设定值：<span>{{ lineB.motor.data24 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    挤出率：<span>{{ lineB.motor.data1 }}</span>
                                                </p>
                                                <p>
                                                    原材料订单：<span>{{ lineB.motor.data9 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    原材料总计：<span>{{ lineB.motor.data10 }}</span>
                                                </p>
                                                <p>
                                                    E1产量实际值：<span>{{ lineB.motor.data6 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    生产线总挤出量实际值：<span>{{ lineB.motor.data7 }}</span>
                                                </p>
                                                <p>
                                                    生产线总挤出量设定值：<span>{{ lineB.motor.data8 }}</span>
                                                </p>
                                            </li>
                                        </div>
                                    </div>
                                </dv-border-box-12>
                            </div>
                            <div class="lowerRight">
                                <dv-border-box-12 :color="['#0E4E80', '#1A92E8']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="lowerRightBox">
                                        <div class="titleGroup">
                                            <div class="titleBox">电机控制台</div>
                                            <!--<div class="toggleButtonGroup">-->
                                            <!--    <a-->
                                            <!--        :class="motorTabActive === 0 ? 'toggleActivation' : ''"-->
                                            <!--        @click="motorTabActive = 0"-->
                                            <!--    >-->
                                            <!--        实时值-->
                                            <!--    </a>-->
                                            <!--    <span>丨</span>-->
                                            <!--    <a-->
                                            <!--        :class="motorTabActive === 1 ? 'toggleActivation' : ''"-->
                                            <!--        @click="motorTabActive = 1"-->
                                            <!--    >-->
                                            <!--        设定值-->
                                            <!--    </a>-->
                                            <!--</div>-->
                                        </div>
                                        <div v-if="motorTabActive === 0" class="contentGroup">
                                            <li>
                                                <p>
                                                    主机当前速度：<span>{{ lineB.motor.data4 }}r/min</span>
                                                </p>
                                                <p>
                                                    主机当前扭矩：<span>{{ lineB.motor.data5 }}%</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    牵引当前速度：<span>{{ lineB.motor.data2 }}m/min</span>
                                                </p>
                                                <p>
                                                    牵引当前扭矩：<span>{{ lineB.motor.data3 }}%</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    当前熔体压力：<span>{{ lineB.motor.data12 }}</span>
                                                </p>
                                            </li>
                                        </div>
                                        <div v-if="motorTabActive === 1" class="contentGroup"></div>
                                    </div>
                                </dv-border-box-12>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </dv-full-screen-container>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import { GET_LINE_B } from "@/api/public";
import TempB from "./components/Temp/TempB.vue";
import LineChangeMoudle from "./components/LineChangeMoudle.vue";

export default {
    name: "LineB",
    components: {
        Swiper,
        SwiperSlide,
        TempB,
        LineChangeMoudle
    },
    data() {
        return {
            lineB: {
                xian: {
                    tc1: 0
                },
                sw: {
                    sw1: 0
                },
                motor: {
                    data2: 0
                }
            },
            swiperOptions: {
                autoplay: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            },
            // 切料控制台tab
            cuttingTabActive: 0,
            // 参数信息tab
            infoTabActive: 0,
            // 电机控制台tab
            motorTabActive: 0
        };
    },
    mounted() {
        this.getLineA();
        setInterval(() => {
            this.getLineA();
        }, 60000);
    },
    methods: {
        getLineA() {
            GET_LINE_B({}).then((res) => {
                if (Number(res.data.code) !== 10000) {
                    this.$message.error(res.data.message);
                    return false;
                }
                this.lineB = res.data.data;
                console.log(res.data.data);
            });
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/style/lineA.scss";
</style>
